/**
 * @generated SignedSource<<baf833790afd77fd43b4f7f49764462e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OptionsSectionFragment$data = {
  readonly id: string;
  readonly isTransferInProgress: boolean;
  readonly issueType: {
    readonly " $fragmentSpreads": FragmentRefs<"IssueTypesDialogIssueType">;
  } | null;
  readonly locked: boolean;
  readonly repository: {
    readonly id: string;
    readonly isExcludedFromIssueTypes: boolean;
    readonly isPrivate: boolean;
    readonly issueTypes: {
      readonly " $fragmentSpreads": FragmentRefs<"IssueTypesDialogIssueTypes">;
    } | null;
    readonly name: string;
    readonly owner: {
      readonly login: string;
    };
  };
  readonly viewerCanDelete: boolean;
  readonly viewerCanTransfer: boolean;
  readonly viewerCanUpdateNext: boolean | null;
  readonly " $fragmentType": "OptionsSectionFragment";
};
export type OptionsSectionFragment$key = {
  readonly " $data"?: OptionsSectionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"OptionsSectionFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OptionsSectionFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTransferInProgress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanUpdateNext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanDelete",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanTransfer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "login",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPrivate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isExcludedFromIssueTypes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 10
            }
          ],
          "concreteType": "IssueTypeConnection",
          "kind": "LinkedField",
          "name": "issueTypes",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "IssueTypesDialogIssueTypes"
            }
          ],
          "storageKey": "issueTypes(first:10)"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "IssueTypesDialogIssueType"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};
})();

(node as any).hash = "2f68e59561e97fc681ab704b4b99793c";

export default node;
